import { getPackagesToSync } from '../utilities/getPackagesToSync.js';
import type { PartialContext } from '../types/Context.js';
import { PerfMeasurementSyncDownload } from '../performance/markers.js';
import { getRemoteCachePromiseResultCounts } from '../utilities/getRemoteCachePromiseResultCounts.js';
import type { SyncResult } from '../types/SyncResult.js';
import { ensureRemoteCacheEnabled } from '../utilities/ensureRemoteCacheEnabled.js';

// TODO: don't hardcode this
const targetEnvironment = 'browser';

/**
 * Download all available packages in the current app's resolve map from the remote cache.
 */
export async function syncDownload(
  input: undefined,
  ctx: PartialContext<
    'packages' | 'packageHashes' | 'remoteCacheClient' | 'telemetryClient',
    'cachePath' | 'config' | 'resolveMap'
  >,
): Promise<SyncResult> {
  const { telemetryClient, remoteCacheClient: client, session } = ctx;

  ensureRemoteCacheEnabled(session.config);

  if (!client) {
    throw new Error('Remote cache client is required to sync upload');
  }

  return await telemetryClient.tracer.startActiveSpan(PerfMeasurementSyncDownload, async (span) => {
    const packagesToSync = await getPackagesToSync({ targetEnvironment }, ctx);

    const downloads = packagesToSync.map((pkg) => client.downloadFolder(pkg));

    // Do not reject if there is a failure. Failed downloads will be logged in the task reporter.
    const promiseResults = await Promise.allSettled(downloads);

    const result = getRemoteCachePromiseResultCounts(promiseResults);
    span.setAttributes(result);

    return result;
  });
}

// This function doesn't have an attached procedure because it's never called via the TRPC server.
